var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:_vm.open ? 'button-is-open' : 'button-is-closed',style:(_vm.open ? 'opacity:0' : 'opacity:1'),attrs:{"id":"gradient-start-button"},on:{"click":function($event){return _vm.$emit('open')}}})}
var staticRenderFns = []

export { render, staticRenderFns }